// Utils
import { assert } from 'ezyvet-fe-helpers';
import getObjectIdRegex from './getObjectIdRegex';
/**
 * Determines if a string is an object id
 *
 * @param {string} value
 *
 * @return {boolean}
 */
export var isObjectId = function (value) {
    assert(typeof value === 'string', 'String required');
    return getObjectIdRegex().test(value);
};
//# sourceMappingURL=isObjectId.js.map